export default __webpack_public_path__ + "static/media/Thief's Belt of the Stolen Kingdom.89c613c5.jpg";